import request from '@/utils/request'

// 获取图形验证码
export function getVerifyCode(data) {
  return request({
    url: '/merchant/user/get-verify',
    method: 'post',
    data,
  })
}

// 发送验证码
export function sendSmsCode(data) {
  return request({
    url: '/merchant/user/send-code',
    method: 'post',
    data,
  })
}

// 提交注册
export function submitRegister(data) {
  return request({
    url: '/merchant/merchant/regist-merchant',
    method: 'post',
    data,
  })
}
